import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

let delay = function (t, v) {
  return new Promise(function (resolve) {
    setTimeout(resolve.bind(null, v), t);
  });
};

const widthTracker = modifier(
  (element, [getDimensions]) => {
    const resizer = () => {
      const rect = element.getBoundingClientRect();
      getDimensions(rect.width, rect.height);
    };
    resizer(); // On first priming, make sure it is off the item
    window.addEventListener('resize', resizer);
    return () => {
      window.removeEventListener('resize', resizer);
    };
  },
  { eager: false },
);

export default class IndexController extends Controller {
  queryParams = ['lang'];
  lang = null;
  @service feedback;
  @service logger;
  @service intl;
  @service('aditools-analytics') analytics;
  @service('aditools-site') siteconfig;
  notificationDialog = { title: '', message: '', enabled: false };
  systemDialog = { message: '', enabled: false };
  trackSize = widthTracker;
  @tracked appWidth;
  consentTitle = '';
  hideCloseX = true;
  hideTitlebar = true;
  toolConfigData = {};

  showNotification(title, message, msgparams) {
    let adjparams = msgparams;
    if (adjparams) {
      adjparams.htmlSafe = 'true';
    } else {
      adjparams = { htmlSafe: 'true' };
    }
    set(this, 'notificationDialog.title', this.intl.t(title, { htmlSafe: 'true' }));
    set(this, 'notificationDialog.message', this.intl.t(message, adjparams));
    set(this, 'notificationDialog.enabled', true);
  }

  systemDialogFunc(status, message) {
    switch (status) {
      case 'ON':
        set(this, 'systemDialog.enabled', true);
        set(this, 'systemDialog.message', this.intl.t(`dialogs.system.${message}`));
        break;
      case 'OFF':
        set(this, 'systemDialog.enabled', false);
        set(this, 'systemDialog.message', '');
        break;
      case 'NONE':
        break;
      default:
        break;
    }
  }

  @action setAppWidth(width) {
    this.appWidth = width;
  }

  @action consentReady() {
    document.querySelector('.aditools-consent-dialog').classList.add('cookie-consent-inserted');
  }

  @action closeNotification() {
    set(this, 'notificationDialog.enabled', false);
    set(this, 'notificationDialog.title', '');
    set(this, 'notificationDialog.message', '');
  }

  @action giveFeedback(model) {
    this.systemDialogFunc('ON', 'application-busy');
    return delay(250)
      .then(() => {
        return;
      })
      .then(() => {
        return this.feedback
          .deliverFeedback(model.name, model.email, model.feedback)
          .then((result) => {
            this.systemDialogFunc('OFF', '');
            if (result.status === 0) {
              this.showNotification('dialogs.feedback.title', 'dialogs.feedback.feedback-dialog-ok-message');
            } else {
              this.showNotification('dialogs.feedback.title', 'dialogs.feedback.feedback-dialog-ng-message');
            }
          })
          .catch((error) => {
            this.showNotification('dialogs.feedback.title', 'dialogs.feedback.feedback-dialog-ng-message');
            this.logger.log('Error:' + error.toString());
          });
      });
  }
  @action closeConsentDialog() {}
}
